import React from 'react';
import LegalPage from '../components/LegalPage';
import Seo from '../components/Seo';

export default function DisclaimerPage() {
  return (
    <LegalPage title="Disclaimer">
      <Seo
        path="/disclaimer"
        title="Disclaimer — LottoPickle"
        description="LottoPickle is for entertainment and education only. Lottery draws are random and past data has no predictive value. Play responsibly."
      />
      <h2>Entertainment & Educational Use Only</h2>
      <p>LottoPickle is a data analysis and visualization platform. All content, tools, and analysis provided on this site are for <strong>entertainment and educational purposes only</strong>. Nothing on this site should be interpreted as advice to purchase lottery tickets or engage in gambling of any kind.</p>

      <h2>Lottery Draws Are Random</h2>
      <p>Official lottery draws — including Powerball and Mega Millions — use certified random number generation equipment regulated by state gaming commissions. Each draw is an independent random event. No statistical analysis of past results, no matter how sophisticated, can predict or influence future outcomes.</p>
      <p>The concept of "hot" or "cold" numbers is a visualization tool for exploring historical data. It does not imply that any number is more or less likely to appear in future draws.</p>

      <h2>No Guarantee of Accuracy</h2>
      <p>Historical draw data is sourced from the New York State government open data portal. While we make every reasonable effort to display accurate data, LottoPickle:</p>
      <ul>
        <li>Does not guarantee the completeness, accuracy, or timeliness of the data</li>
        <li>Is not responsible for errors or omissions in source data</li>
        <li>Does not guarantee that our own processing, calculation, or presentation of that data is free from error</li>
        <li>Is not affiliated with, endorsed by, or connected to any official lottery organization</li>
        <li>Does not represent that any analysis is mathematically predictive</li>
      </ul>
      <p>Always treat official lottery results as authoritative. If a figure here disagrees with the official record, the official record is correct.</p>

      <h2>Rule Changes and Comparability</h2>
      <p>Lotteries change their number ranges from time to time. Powerball drew from 1&ndash;59 until October 2015 and 1&ndash;69 afterwards; Mega Millions has changed range four times. A number added by one of these changes has had fewer opportunities to appear than one that has been drawn throughout, so raw counts from either side of a change are not directly comparable.</p>
      <p>For this reason LottoPickle shows the current number format by default. Selecting <strong>All time</strong> deliberately spans multiple formats: the counts are accurate, but the resulting hot and cold rankings will favour numbers that have simply been in play longer. This is a property of the underlying rule changes, not of the draw.</p>
      <p>If something on this site looks wrong to you, please tell us at <a href="mailto:info@lottopickle.com">info@lottopickle.com</a>. Corrections are welcome and we would rather hear about them.</p>

      <h2>Responsible Play</h2>
      <p>Lottery participation should always be within your personal budget and for entertainment only. If you or someone you know has a problem with gambling, help is available:</p>
      <ul>
        <li><strong>National Problem Gambling Helpline:</strong> 1-800-522-4700</li>
        <li><strong>National Council on Problem Gambling:</strong> ncpgambling.org</li>
        <li><strong>Gamblers Anonymous:</strong> gamblersanonymous.org</li>
      </ul>

      <h2>No Financial Advice</h2>
      <p>Nothing on LottoPickle constitutes financial advice. We do not recommend spending money on lottery tickets as an investment strategy. The expected value of any lottery ticket is negative.</p>

      <h2>Third-Party Links</h2>
      <p>This site may contain links to third-party websites. LottoPickle is not responsible for the content, privacy practices, or accuracy of any linked sites.</p>

      <h2>Contact</h2>
      <p>Questions about this disclaimer? Contact us at <a href="mailto:info@lottopickle.com">info@lottopickle.com</a>.</p>
    </LegalPage>
  );
}
